<template>
    <div class="layout__padding-clear layout__width-100">
        <div class="layout__position__relative">
            <div class="grad"></div>
            <img class="layout__width-100 layout__height-100 layout__padding-clear"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/design-studio-2000x750.jpg">
            <div class="layout__padding-clear">
                <div class="component__banner-title layout__padding-clear">Design Studio
                    <div class="text__size-20 text__line-height-30px layout__padding-20-0">
                        <div class="layout__padding-clear layout__width-50">
                            Bring your vision to life by working with
                            our talented team of design professionals.
                            Whether it's print, digital or both, we'll help you get the most out of your marketing.
                        </div>
                    </div>
                    <el-button class="button-white-grey button__base__header-large layout__width-200px" v-on:click="work()">
                        See our work
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__width-70 layout__padding-clear">
            <div class="text__size-36 text__colour-teal layout__width-100 text__align-center text__style-bold-900 text__line-height-2 layout__padding__top-20px">
                Make your property marketing easy on the eye
            </div>
            <hr>

            <p class="text__line-height-30px text__align-center">
                We are property industry experts. It’s a bold claim, we know, but we understand this industry inside out. Head turning marketing materials
                and stand out branding are the tools you need to get noticed in a competitive market, and because our
                design team has over 200 years combined experience in the property sector, you’re in safe hands with us.
                We’ll support you at every step of your property journey.
            </p>

            <hr>

            <div class="layout__padding-20-0 text__align-center">
                <a href="https://ravensworth.co.uk/pricelist/" target="_blank">
                <el-button class="layout__width-200px button-red">Design Price List
                </el-button>
                </a>
            </div>

            <p class="layout__margin-20-0 link__colour-black text__align-center">
                For a bespoke design quote,
                <router-link class="link__colour-teal" to="/contact">click here</router-link>
            </p>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                Our work
            </div>

            <div class="layout__padding-clear layout__width-80">
                <div class="component__columns-2">
                    <div class="layout__margin__top-15p">
                        <div class="text__colour-teal text__size-21 text__style-bold-700">
                            Print
                        </div>
                        <hr>

                        <p class="text__style-bold-700 text__line-height-30px">If you’re looking for something to
                            set your brand apart from the
                            rest, we’ve got you covered. </p>

                        <p class="layout__padding__top-20px text__line-height-30px">
                            Whether it’s a full rebrand with
                            marketing materials or a beautiful business card, no job is
                            too big or small for our talented team. Trust us – we’re the kind of people that get
                            excited about paper stocks!
                        </p>

                        <hr>

                        <div class="layout__padding-20-0">
                            <el-button class="layout__width-200px button-red"
                                       v-on:click="print()">Print Products
                            </el-button>
                        </div>

                    </div>
                </div>
                <div class="component__columns-2">
                    <div class="">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/print-mockup700px.jpg">
                    </div>
                </div>
            </div>

        </div>

        <div class="layout__margin-40-0">
            <div class="layout__padding-clear layout__width-80">
                <div class="component__columns-2">
                    <div class="">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/Digital-mockup-700.png">
                    </div>
                </div>
                <div class="component__columns-2">

                    <div class="layout__margin__top-15p">
                        <div class="text__colour-teal text__size-21 text__style-bold-700">
                            Digital
                        </div>
                        <hr>

                        <p class="text__style-bold-700 text__line-height-30px">Our digital solutions help to boost your
                            brand’s reach and influence.</p>

                        <p class="layout__padding__top-20px text__line-height-30px">
                            Sensational social media is just the start… We build everything from microsites and email
                            signatures to digital window cards and property brochures, making sure your brand or
                            development looks extraordinary both onscreen and in print.
                        </p>

                        <hr>

                        <div class="layout__padding-20-0">
                            <el-button class="layout__width-200px button-red"
                                       v-on:click="digital()">Digital Products
                            </el-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-36 text__colour-teal layout__width-100 text__align-center text__style-bold-900 text__line-height-2 layout__padding__top-20px">
                What our customers say
            </div>
            <div class="layout__overflow-hidden text__line-height-15 layout__width-70 layout__padding-clear">
                <div class="layout__padding-clear layout__width-100 text__align-center">
                    <carousel :per-page="1" :autoplayTimeout="5000" :autoplay="true" :paginationSize="20" paginationActiveColor="#00859c" :loop="true" :speed="1500">
                        <slide class="layout__padding-clear layout__height-300px" v-for="(test) in testimonials">
                            <img class="layout__padding-clear layout__width-150px" v-bind:src=test.logo>
                            <div class="layout__padding-clear layout__width-80">
                                <p class="layout__padding-20px text__size-18 text__line-height-30px">{{test.message}}</p>
                                <p class="text__size-16">{{test.company}}</p>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {
                showPreview: false,
                testimonials: [
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/js.png',
                        message: '“Proactive, creative, great problem solving attitude… Ravensworth shares Jackson-Stops\' insistence for the highest possible standards."',
                        company: 'Nick Ferrier - Jackson-Stops'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/connells.png',
                        message: '"Ravensworth produce high quality CGI every time and pay great attention to the features that turn a house into a home. They\'re an invaluable marketing partner that add real value."',
                        company: 'Paul Matthews - Connells'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/realEstates.png',
                        message: '"Ravensworth\'s Marketing Toolkit helps us cut down on time and money without comprimising on quality and we can deliver fast, effecting marketing campaigns."',
                        company: 'Peter Clifford - Reel Estates'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/holroyds.png',
                        message: '“Ravensworth share our vision and passion for the industry. They’ve helped us create the perfect marketing plan to stand out from the crowd. Their quality and attention to detail impress on a daily basis.”',
                        company: 'Chris Holroyd - Holroyds Estate Agents'
                    }
                ]
            }
        },
        created() {
        },
        methods: {
            contactUs() {
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            work() {
                Router.push({
                    name: '/services/design-studio/our-work'
                });
            }
        },
    };
</script>